import React from "react";
import "../styles/pages/Home.css";
import ParticlesBackground from "../components/Effects/ParticlesBackground";
import NewsSlider from "../components/News/NewsSlider";
import AuthSidebar from "../components/Auth/AuthSidebar";
import { useLanguage } from "../contexts/LanguageContext";

const Home: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="home-page">
      <ParticlesBackground />

      {/* Contenido principal */}
      <div className="main-content">
        <div className="main-panel">
          {/* Sección de Noticias */}
          <NewsSlider />

          {/* Sección de características */}
          <section className="features-section">
            <h2 className="section-title">{t("home", "features.title")}</h2>

            <div className="features">
              <div className="feature-card">
                <div className="feature-icon">⚔️</div>
                <h3>{t("home", "features.items.combat.title")}</h3>
                <p>{t("home", "features.items.combat.description")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🌌</div>
                <h3>{t("home", "features.items.world.title")}</h3>
                <p>{t("home", "features.items.world.description")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">📜</div>
                <h3>{t("home", "features.items.legends.title")}</h3>
                <p>{t("home", "features.items.legends.description")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🎭</div>
                <h3>{t("home", "features.items.characters.title")}</h3>
                <p>{t("home", "features.items.characters.description")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🔮</div>
                <h3>{t("home", "features.items.magic.title")}</h3>
                <p>{t("home", "features.items.magic.description")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🏰</div>
                <h3>{t("home", "features.items.castles.title")}</h3>
                <p>{t("home", "features.items.castles.description")}</p>
              </div>
            </div>

            <div className="game-embed">
              <iframe
                title="Aethelbur Chronicles on Itch.io"
                frameBorder="0"
                src="https://itch.io/embed/3800740?linkback=true&amp;border_width=5&amp;bg_color=9b8888&amp;link_color=ad5bfa&amp;border_color=918337"
                width="560"
                height="175"
              >
                <a href="https://orial022.itch.io/aethelburg">
                  Aethelbur Chronicles by Orial022
                </a>
              </iframe>
            </div>
          </section>
        </div>

        {/* Panel lateral */}
        <AuthSidebar />
      </div>
    </div>
  );
};

export default Home;
